const removeSpecialChar = (search) => {
  if (typeof search === 'string') {
    return search.replaceAll('.', '').replaceAll('-', '');
  }
};

export default removeSpecialChar;
